import { AvailableLocales, routing } from '@onclicks/sharedmobilei18n/routing';

export type Language = {
	code: AvailableLocales;
	titlePage: string;
	name: string;
	flag: string;
	validateButton: string;
};

export const languages: Language[] = [
	{ code: 'en', titlePage: 'Language', name: 'English', flag: '🇬🇧', validateButton: 'Confirm' },
	{ code: 'nl', titlePage: 'Taal', name: 'Nederlands', flag: '🇳🇱', validateButton: 'Bevestigen' },
	{ code: 'fr', titlePage: 'Langue', name: 'Français', flag: '🇫🇷', validateButton: 'Valider' },
];

// Langue par défaut de l'app (indépendante de routing.defaultLocale) : le backend
// considère le Français comme défaut (langue = 0) et c'est le fallback demandé.
export const DEFAULT_LOCALE: AvailableLocales = 'fr';

// Encodage backend de la langue (entier) : 0 = FR, 1 = EN, 2 = NL.
export const LANGUE_BY_LOCALE: Record<AvailableLocales, number> = {
	fr: 0,
	en: 1,
	nl: 2,
};

const LOCALE_BY_LANGUE: Record<number, AvailableLocales> = {
	0: 'fr',
	1: 'en',
	2: 'nl',
};

const LOCALE_SET = new Set(routing.locales as readonly string[]);

/** Locale UI → entier `langue` attendu par le backend (défaut FR). */
export const localeToLangue = (locale: AvailableLocales | undefined): number =>
	locale ? LANGUE_BY_LOCALE[locale] : LANGUE_BY_LOCALE[DEFAULT_LOCALE];

/** Entier `langue` du backend → locale UI (fallback FR si absent/inconnu). */
export const langueToLocale = (langue: number | null | undefined): AvailableLocales =>
	(langue != null && LOCALE_BY_LANGUE[langue]) || DEFAULT_LOCALE;

/**
 * Claim Keycloak `locale` ("fr"/"en"/"nl", éventuellement "fr-BE") → locale UI.
 * Fallback FR si le claim est absent ou non supporté.
 */
export const keycloakLocaleToLocale = (claim: string | null | undefined): AvailableLocales => {
	const normalized = claim?.toLowerCase().split(/[-_]/)[0];
	return normalized && LOCALE_SET.has(normalized) ? (normalized as AvailableLocales) : DEFAULT_LOCALE;
};